module.exports = __webpack_public_path__ + "img/visa.17821423.svg";